import Hammer from 'hammerjs';

class ActivityModal {
  constructor(element, open = false) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.handle = element.querySelector('.modal__handle');
    this.overlay = element.querySelector('.modal__overlay');
    this.content = element.querySelector('.modal__container');
    this.close = element.querySelector('.modal__close');

    if (open) {
      MicroModal.show(this.element.id);
    }

    if (window.location.hash === `#${element.id}`) {
      MicroModal.show(this.element.id);
    }

    this.initHandle();
    this.initBackdrop();
  }

  initBackdrop() {
    if (this.content) {
      this.content.addEventListener('click', (ev) => {
        ev.stopImmediatePropagation();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (ev) => {
        if (window.outerWidth > 768) {
          this.closeModal();
        }
      });
    }
  }

  initHandle() {
    if (this.handle) {
      this.hammer = new Hammer(this.handle);

      this.hammer
        .get('swipe')
        .set({ direction: Hammer.DIRECTION_VERTICAL });

      this.hammer.on('swipedown', this.closeModal.bind(this));
    }

    if (this.close) {
      this.close.addEventListener('click', this.closeModal.bind(this));
    }
  }

  closeModal() {
    console.log('Closing ', this.element.id);
    MicroModal.close(this.element.id);
  }
}

export default ActivityModal;
